import { render, staticRenderFns } from "./ApplicantParentInformation.vue?vue&type=template&id=0c0097fc&scoped=true&"
import script from "./ApplicantParentInformation.vue?vue&type=script&lang=js&"
export * from "./ApplicantParentInformation.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantParentInformation.vue?vue&type=style&index=0&id=0c0097fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0097fc",
  null
  
)

export default component.exports